import { inject, Injectable } from '@angular/core';
import { _AuthBaseStore, AuthBaseStoreLoginModel, AuthBaseStoreProps } from '@controladad/ng-base';
import { AuthApiService } from '../services';
import { UserEntity } from '@models';
import { map } from 'rxjs';

export interface AuthStoreProp extends AuthBaseStoreProps<UserEntity> {}
export interface AuthStoreLoginModel extends AuthBaseStoreLoginModel {}

@Injectable({
  providedIn: 'root'
})
export class AuthStore extends _AuthBaseStore<AuthStoreProp, AuthStoreLoginModel> {
  private authApi = inject(AuthApiService);

  constructor() {
    super({
      loginApi: (model) => this.authApi.login({
        email: model.username,
        password: model.password,
        deviceId: '',
        fcm: ''
      }).pipe(map((res) => ({
        token: res.token,
        user: res.userDetails
      }))),
      meApi: () => this.authApi.me().pipe(map(res => res.userDetails)),
    });
  }

  override isSuper(): boolean {
    return this.state.user?.roles.includes('Admin') ?? false;
  }

  isRestrictedAdmin(): boolean {
    return this.state.user?.isRestrictedAdmin ?? false;
  }
}
